module.exports = "/virtual-football-league/img/amblems/left/logos/Broomwich.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Broomwich.png
// module id = 2060
// module chunks = 4